<template>
    <div class="settings_payment">
      <loading v-if="loading"/>
      <!-- 支付設定 -->
      <section class="chapternav-top">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <h2 class="section-heading text-uppercase">Payment</h2>
              <h3 class="section-subheading text-muted">支付設定</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 setting-payment-box">
              <div class="setting-payment">

                    <ul>
                      
                      <li>
                          
                          <div id="setting-payment-option">
                                <div class="form-check setting-payment-item">
                                  <input class="form-check-input" type="radio" name="setting-payment-item" id="setting-payment-radios1" value="0" v-model="profile.paid_type">
                                  <label class="form-check-label" for="setting-payment-radios1">
                                    Line Pay
                                  </label>
                                </div>
                                <!--
                                <div class="form-check setting-payment-item">
                                  <input class="form-check-input" type="radio" name="setting-payment-item" id="setting-payment-radios2" value="1" v-model="profile.paid_type">
                                  <label class="form-check-label" for="setting-payment-radios2">
                                    電信小額支付
                                  </label>
                                </div>
                                -->
                          </div>

                      </li>
                      
                  </ul>

              </div>
              <div class="btn-send">
                <a class="btn btn-primary js-scroll-trigger" href="#" v-on:click="saveSetting()">儲存設定</a>
              </div>
            </div>
            
          </div>
        </div>
      </section>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'SettingsPayment',
  components: {
  },
  props: {
  },
  data() {
    return {
      profile: {
      },
      loading: true
    }
  },
  mounted() {
    var self = this;
    self.getProfile()
  },
  methods: {
    getProfile: function() {
      var self = this
      self.$http.get('https://'+ process.env.VUE_APP_API_URL +'/users/profile?access_token=' + self.$cookie.get('access_token'))
        .then((response) => {
          self.profile = response.body
          self.loading = false
        })
        .catch((response) => {
          console.log("取得資料失敗")
          self.$router.push({ name: 'member_center' })
        })
        .finally(() => {
        });
    },
    saveSetting: function() {
      var self = this
      self.loading = true
      self.$http.post('https://' + process.env.VUE_APP_API_URL + '/users/paid_type?access_token=' + self.$cookie.get('access_token'), {
        paid_type: self.profile.paid_type
      })
      .then((response) => {
        self.loading = false
      })
      .catch((response) => {
        console.log("fail for post new plate")
      })
      .finally(() => {
      });
    }
  }
}
</script>